import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { StringCustomFieldConfig, SharedModule, FormInputComponent } from '@vendure/admin-ui/core';

@Component({
    template: `
        <input class="hidden-field" type="text" readOnly [formControl]="formControl" />
    `,
    styleUrls: ['./hidden-input.component.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class HiddenInputFormComponent implements FormInputComponent<StringCustomFieldConfig> {
    readonly: boolean;
    config: StringCustomFieldConfig;
    formControl: FormControl;
}
